import React from 'react';
import styles from './Colors.module.scss';
import { groupColors, GroupColorHex } from '@repo/utils/models/Group';
import { ColorOption } from '@repo/components/forms';

export default function Colors({
  active = null,
  onSelect,
}: {
  active: GroupColorHex;
  onSelect: (hex: string) => void;
}) {
  return (
    <div className={styles.colorList}>
      {groupColors.map(([hex, label], i) => (
        <ColorOption
          active={active === hex}
          onMouseDown={() => onSelect(hex)}
          hex={hex}
          label={label}
          key={i}
        />
      ))}
    </div>
  );
}
